"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));

var _reactDnd = require("react-dnd");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _pickers = require("@material-ui/pickers");

var _clsx = _interopRequireDefault(require("clsx"));

var _FormItemsProperties = _interopRequireDefault(require("../../components/FormItemsProperties"));

var _FormContainersDnd = _interopRequireDefault(require("../../components/FormContainersDnd"));

var _FormItemsDnd = _interopRequireDefault(require("../../components/FormItemsDnd"));

var _urls = require("../../utils/urls");

var _Loading = _interopRequireDefault(require("../../components/Loading"));

var _Footer = _interopRequireDefault(require("../../components/Footer"));

var _Modal = _interopRequireDefault(require("../../components/Modal"));

var _services = _interopRequireDefault(require("../../services"));

var _utils = _interopRequireDefault(require("../../utils"));

require("react-grid-layout/css/styles.css");

require("react-resizable/css/styles.css");

require("moment/locale/es");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      flexGrow: 1
    },
    title: {
      fontSize: 14
    },
    cardHeader: {
      textAlign: "center",
      borderBottom: "1px solid #c5c5c5",
      padding: 5
    },
    flexEnd: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: 20
    },
    paddingLeft10: {
      paddingLeft: 10
    },
    paddingRight10: {
      paddingRight: 10
    },
    marginBottom: {
      marginBottom: "20%"
    }
  };
});

function FormCreate(props) {
  var classes = useStyles();
  var containerRef = /*#__PURE__*/(0, _react.createRef)();

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      itemProperties = _useState2[0],
      setItemProperties = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      objectsForm = _useState4[0],
      setObjectsForm = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openProperties = _useState6[0],
      setOpenProperties = _useState6[1];

  var _useState7 = (0, _react.useState)(1),
      _useState8 = _slicedToArray(_useState7, 2),
      gridSize = _useState8[0],
      setGridSize = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = _slicedToArray(_useState9, 2),
      openModal = _useState10[0],
      setOpenModal = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      stateLoading = _useState12[0],
      setStateLoading = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = _slicedToArray(_useState13, 2),
      formName = _useState14[0],
      setFormName = _useState14[1];

  var _useState15 = (0, _react.useState)("simple"),
      _useState16 = _slicedToArray(_useState15, 2),
      typeForm = _useState16[0],
      setTypeForm = _useState16[1];

  var _useState17 = (0, _react.useState)(2),
      _useState18 = _slicedToArray(_useState17, 2),
      multiple = _useState18[0],
      setMultiple = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = _slicedToArray(_useState19, 2),
      isAdvance = _useState20[0],
      setIsAdvance = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = _slicedToArray(_useState21, 2),
      isStaticHeigth = _useState22[0],
      setIsStaticHeigth = _useState22[1];

  var _useState23 = (0, _react.useState)(0),
      _useState24 = _slicedToArray(_useState23, 2),
      containerPaddingSizeX = _useState24[0],
      setContainerPaddingSizeX = _useState24[1];

  var _useState25 = (0, _react.useState)(0),
      _useState26 = _slicedToArray(_useState25, 2),
      containerPaddingSizeY = _useState26[0],
      setContainerPaddingSizeY = _useState26[1];

  var _useState27 = (0, _react.useState)(0),
      _useState28 = _slicedToArray(_useState27, 2),
      marginSizeX = _useState28[0],
      setMarginSizeX = _useState28[1];

  var _useState29 = (0, _react.useState)(0),
      _useState30 = _slicedToArray(_useState29, 2),
      marginSizeY = _useState30[0],
      setMarginSizeY = _useState30[1];

  var _useState31 = (0, _react.useState)(false),
      _useState32 = _slicedToArray(_useState31, 2),
      isAutoSize = _useState32[0],
      setIsAutoSize = _useState32[1];

  var _useState33 = (0, _react.useState)(false),
      _useState34 = _slicedToArray(_useState33, 2),
      isAllowOverlap = _useState34[0],
      setIsAllowOverlap = _useState34[1];

  var _useState35 = (0, _react.useState)(false),
      _useState36 = _slicedToArray(_useState35, 2),
      isPreventCollision = _useState36[0],
      setIsPreventCollision = _useState36[1];

  var _useState37 = (0, _react.useState)(false),
      _useState38 = _slicedToArray(_useState37, 2),
      isShowGrids = _useState38[0],
      setIsShowGrids = _useState38[1];

  var _useState39 = (0, _react.useState)(50),
      _useState40 = _slicedToArray(_useState39, 2),
      staticHeight = _useState40[0],
      setStaticHeight = _useState40[1];

  var _useState41 = (0, _react.useState)(2),
      _useState42 = _slicedToArray(_useState41, 2),
      advanceCount = _useState42[0],
      setAdvanceCount = _useState42[1];

  var _useState43 = (0, _react.useState)({
    formName: ""
  }),
      _useState44 = _slicedToArray(_useState43, 2),
      errModal = _useState44[0],
      setErrModal = _useState44[1];

  var maxColumnsNumber = 16;
  var optionsGridLayout = {
    isStaticHeigth: isStaticHeigth,
    containerPaddingSizeX: containerPaddingSizeX,
    containerPaddingSizeY: containerPaddingSizeY,
    marginSizeX: marginSizeX,
    marginSizeY: marginSizeY,
    isAutoSize: isAutoSize,
    isAllowOverlap: isAllowOverlap,
    isPreventCollision: isPreventCollision,
    isShowGrids: isShowGrids,
    staticHeight: staticHeight
  };
  console.log("objectsForm: ", objectsForm);
  console.log("gridSize: ", gridSize); // si es form multiple, establece 1 de grid

  (0, _react.useEffect)(function () {
    if (typeForm === "multiple") setGridSize(1);
  }, [typeForm, isAdvance]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var itemsMenu = [{
    name: "",
    label: "Acordeon",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "accordion",
    attributes: {
      disabled: false
    },
    minH: 1,
    maxH: 1,
    dependencies: [],
    source: null,
    validations: null,
    childs: [],
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "label",
    attributes: {
      label: "Etiqueta",
      type: "label",
      variant: "h1",
      bold: false,
      justifyContent: "flex-start",
      alignItems: "flex-start",
      hasTitle: false,
      color: "#000000de"
    },
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: null,
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "input",
    attributes: {
      label: "Etiqueta",
      placeholder: "",
      type: "text",
      value: "",
      maxLength: null,
      min: null,
      max: null
    },
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: {
      allowNull: false,
      customRequiredMessage: "",
      customValidation: "",
      customValidationMessage: ""
    },
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "date",
    attributes: {
      label: "Etiqueta",
      placeholder: "",
      type: "date",
      value: null
    },
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: {
      allowNull: false,
      customRequiredMessage: "",
      customValidation: "",
      customValidationMessage: ""
    },
    isBirthday: false,
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 2,
    classes: "",
    type: "textarea",
    attributes: {
      label: "Etiqueta",
      placeholder: "",
      type: "textarea",
      value: "",
      maxLength: null
    },
    minH: 2,
    maxH: 2,
    dependencies: null,
    source: null,
    validations: {
      allowNull: false,
      customRequiredMessage: "",
      customValidation: "",
      customValidationMessage: ""
    },
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    count: 1,
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "checkbox",
    attributes: [{
      labelInside: "Activo",
      type: "checkbox",
      value: false
    }],
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: null,
    childAccordion: null,
    value: "default",
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    label: "Etiqueta",
    count: 2,
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "radio",
    attributes: [{
      labelInside: "Radio",
      type: "radio",
      value: ""
    }, {
      labelInside: "Radio",
      type: "radio",
      value: ""
    }],
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: null,
    required: false,
    value: "default",
    childAccordion: null,
    color: "#000000de",
    isBtn: false,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "select",
    attributes: {
      label: "Etiqueta",
      placeholder: "",
      value: "",
      type: "select"
    },
    dependencies: [],
    minH: 1,
    maxH: 1,
    source: {
      type: 1,
      parameters: {},
      defaultValues: []
    },
    validations: {
      allowNull: false
    },
    isChild: {
      parentId: null
    },
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "button",
    attributes: {
      variant: "contained",
      label: "Enviar",
      color: "primary",
      align: "flex-end",
      fullWidth: false
    },
    dependencies: null,
    source: {
      type: 2,
      parameters: {
        server: _urls.API_URL,
        service: {
          name: "form-saved-data",
          url: "form-builder"
        },
        operation: "POST",
        metadata: ""
      },
      defaultValues: []
    },
    minH: 1,
    maxH: 1,
    validations: null,
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }, {
    name: "",
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "",
    type: "image",
    attributes: {
      type: "image",
      label: "Imagen",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      src: "https://discountseries.com/wp-content/uploads/2017/09/default.jpg",
      alt: "speedform-img",
      width: "50",
      height: "60"
    },
    minH: 1,
    maxH: 1,
    dependencies: null,
    source: null,
    validations: null,
    childAccordion: null,
    isActiveCustomStyles: false,
    customStyles: {}
  }
  /* ,
  {
     name: "",
     label: "Contenedor",
     x: 0,
     y: 0,
     w: 1,
     h: 1,
     classes: "",
     type: "container",
     attributes: {
       disabled: false,
     },
     minH: 1,
     maxH: 1,
     dependencies: null,
     source: null,
     validations: null,
     childAccordion: null,
   }, */
  ]; // si el id no es null es edit

  var id = (0, _react.useMemo)(function () {
    return props.match ? props.match.params.id : props.id;
  }, [props.match, props.id]); // effect para el edit

  var isEdit = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!id) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return (0, _services.default)("".concat(_urls.API_FULL, "/form-builders/").concat(id), props.token);

          case 3:
            _context.t0 = _context.sent;
            _context.next = 7;
            break;

          case 6:
            _context.t0 = null;

          case 7:
            response = _context.t0;

            if (id) {
              setStateLoading(response && !response.data.length ? false : true);
            }

            if (response) {
              console.log("response: ", response);
              setGridSize(response.gridSize);
              setObjectsForm(response.data);
              setFormName(response.name);
              setMultiple(response.multiple);
              setIsAdvance(response.isAdvance);
              setAdvanceCount(response.advanceCount);
              setTypeForm(response.typeForm);
              setIsStaticHeigth(response.isStaticHeigth);
              setContainerPaddingSizeX(response.containerPaddingSizeX);
              setContainerPaddingSizeY(response.containerPaddingSizeY);
              setMarginSizeX(response.marginSizeX);
              setMarginSizeY(response.marginSizeY);
              setIsAutoSize(response.isAutoSize);
              setIsAllowOverlap(response.isAllowOverlap);
              setIsPreventCollision(response.isPreventCollision);
              setStaticHeight(response.staticHeight); // update state

              localStorage.setItem("formName", response.name);
              localStorage.setItem("gridSize", response.gridSize);
              localStorage.setItem("multiple", response.multiple);
              localStorage.setItem("isAdvance", response.isAdvance);
              localStorage.setItem("advanceCount", response.advanceCount);
              localStorage.setItem("typeForm", response.typeForm);
              localStorage.setItem("optionsGridLayout", optionsGridLayout);
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [id, props]);
  (0, _react.useEffect)(function () {
    if (id) {
      setOpenModal(false);
      setStateLoading(true);
    }

    isEdit();
  }, [isEdit, id]);

  var handleItemSelected = function handleItemSelected(item, key) {
    console.log("handleItemSelected item: ", item);
    console.log("handleItemSelected key: ", key);
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;
      oF.classes = "";

      if (oForm.i === key) {
        setItemProperties(oF);
        oF.classes = item.type === "radio" || item.type === "checkbox" ? "dnd-highlight-radio" : "dnd-highlight";
        setOpenProperties(true);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemPropertiesChange = function handleItemPropertiesChange(layout) {
    console.log("handleItemPropertiesChange layout: ", layout);
    var tmp = objectsForm.map(function (oForm, idx) {
      var oF = oForm;
      oF.classes = "";

      if (oForm.i === layout[idx].i) {
        oF.x = layout[idx].x;
        oF.y = layout[idx].y;
        oF.w = layout[idx].w;
        oF.h = layout[idx].h;
        oF.classes = "dnd-highlight";
      }

      return oF;
    });
    setObjectsForm(tmp);
  };

  var handleRemoveItem = function handleRemoveItem(item) {
    var selectParentId = null;

    if (item.type === "select") {
      selectParentId = item.i;
    } // eslint-disable-next-line array-callback-return


    var objectsFormTmp = objectsForm.filter(function (oForm) {
      if (oForm.i !== item.i) {
        var _oForm$isChild;

        var condition = (_oForm$isChild = oForm.isChild) !== null && _oForm$isChild !== void 0 && _oForm$isChild.parentId ? oForm.isChild.parentId : undefined;

        if (selectParentId !== condition) {
          return oForm;
        }
      }
    });
    setOpenProperties(false);
    setObjectsForm(objectsFormTmp);

    if (!objectsFormTmp.length) {
      setStateLoading(false);
    }
  };

  var handleAddItemForm = function handleAddItemForm(itemToForm) {
    console.log("handleAddItemForm itemToForm: ", itemToForm);
    var newItem = itemToForm;
    var isExists = objectsForm.some(function (ob) {
      return ob.i === newItem.i;
    }); // create

    if (!isExists) {
      newItem.name = "".concat(newItem.type).concat(objectsForm.filter(function (oForm) {
        return oForm.type === newItem.type;
      }).length);
      newItem.i = _utils.default.getNewId();
      console.log("handleAddItemForm newItem: ", newItem);
      setObjectsForm([].concat(_toConsumableArray(objectsForm), [newItem]));
      return;
    } // update
    // setObjectsForm((prevData) => [...prevData, newItem]);


    var tmp = objectsForm.map(function (ob) {
      if (ob.i === newItem.i) {
        ob = newItem;
      }

      return ob;
    });
    setObjectsForm(tmp);
  };

  var handleItemPropertyChange = function handleItemPropertyChange(item, key, value) {
    console.log("handleItemPropertyChange: ", item, key, value);
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;

      if (oForm.i === item.i) {
        oF[key] = value;
        setItemProperties(oF);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemAttribute = function handleItemAttribute(item, key, value) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    console.log("handleItemAttribute: ", item, key, value, index);
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;

      if (oForm.i === item.i) {
        if (item.type === "radio" || item.type === "checkbox") {
          // change only label or count
          if (key === "label" || key === "count") {
            oF[key] = value;

            if (key === "count") {
              // clone elements
              if (item.type === "radio") {
                for (var i = 2; i < value; i++) {
                  oF.attributes.push({
                    labelInside: "Radio",
                    type: "radio",
                    value: ""
                  });
                }
              } else if (item.type === "checkbox") {
                for (var _i2 = 1; _i2 < value; _i2++) {
                  oF.attributes.push({
                    labelInside: "Activo",
                    type: "checkbox",
                    value: false
                  });
                }
              }

              oF.attributes.length = value;
            }
          } else {
            // change properties (array)
            if (index !== null) {
              oF.attributes[index][key] = value;
            } else {
              // change other properties
              if (key === "required") {
                oF[key] = value;
              } else {
                oF.attributes[key] = value;
              }
            }
          }
        } else {
          oF.attributes[key] = value;
        }

        setItemProperties(oF);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemValidation = function handleItemValidation(item, key, value) {
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;

      if (oForm.i === item.i) {
        oF.validations[key] = value;
        setItemProperties(oF);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemSource = function handleItemSource(item, key, value) {
    var doubleKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var parameters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var objectsFormTmp = objectsForm.map(function (oForm) {
      var oF = oForm;

      if (oForm.i === item.i) {
        if (doubleKey) {
          var spl = key.split(".");
          oF.source.parameters[spl[0]][spl[1]] = value;
        } else {
          parameters ? oF.source.parameters[key] = value : oF.source[key] = value;
        }

        setItemProperties(oF);
      }

      return oF;
    });
    setObjectsForm(objectsFormTmp);
  };

  var handleItemDependencies = function handleItemDependencies(item, value, action) {
    console.log("handleItemDependencies: ", item, value, action);
    var objectsFormTmp;

    if (action === "create") {
      objectsFormTmp = objectsForm.map(function (oForm) {
        var oF = oForm;

        if (oForm.i === item.i) {
          oF.dependencies.push(value);
          setItemProperties(oF);
        }

        return oF;
      });
    }

    if (action === "delete") {
      // delete dependency
      var deps = item.dependencies.filter(function (dep) {
        return dep.i !== value;
      });
      objectsFormTmp = objectsForm.map(function (oForm) {
        var oF = oForm;

        if (oForm.i === item.i) {
          oF.dependencies = deps;
          setItemProperties(oF);
        }

        return oF;
      }).filter(function (f) {
        return f.i !== value;
      });
    }

    if (action === "update") {
      objectsFormTmp = objectsForm.map(function (oForm) {
        if (oForm.i === item.i) {
          var tmp = oForm.dependencies.map(function (f) {
            if (f.i === value.i) {
              f = value;
            }

            return f;
          });
          oForm.dependencies = tmp;
          setItemProperties(oForm);
        }

        return oForm;
      });
    }

    setObjectsForm(objectsFormTmp);
  };

  var handleModal = function handleModal(val) {
    return setOpenModal(val);
  };

  var handleOpenModal = function handleOpenModal() {
    return setOpenModal(true);
  };

  var validateNumber = function validateNumber(e) {
    var val = Number(e.target.value);
    var setValue = val <= maxColumnsNumber ? val : 1;
    setGridSize(setValue < 0 ? 1 : setValue);
  };

  var validateFormName = function validateFormName(e) {
    setFormName(e.target.value);
    setErrModal({
      formName: ""
    });
  };

  var validateModal = (0, _react.useCallback)(function (e) {
    e.preventDefault();

    if (formName === "") {
      setErrModal({
        formName: "Debe agregar un nombre al formulario"
      });
    } else {
      // crear acordiones
      if (typeForm === "multiple") {
        var accordionsToStepsWizard = Array(multiple).fill(itemsMenu[0]).map(function (el, key) {
          return _objectSpread(_objectSpread({}, el), {}, {
            i: "step-".concat(key + 1),
            label: "Step Wizard ".concat(key + 1)
          });
        });

        if (isAdvance) {
          var data = [{
            name: "",
            label: "Vista inicial (agregar parientes)",
            x: 0,
            y: 0,
            w: 1,
            h: 1,
            classes: "",
            type: "accordion",
            attributes: {
              disabled: false
            },
            minH: 1,
            maxH: 1,
            dependencies: [],
            source: null,
            validations: null,
            childs: [],
            i: "step-0"
          }].concat(_toConsumableArray(accordionsToStepsWizard), _toConsumableArray(objectsForm));
          var seen = new Set();
          var filteredArr = data.filter(function (el) {
            var duplicate = seen.has(el.i);
            seen.add(el.i);
            return !duplicate;
          });
          setObjectsForm(filteredArr);
        } else {
          var _data = [].concat(_toConsumableArray(accordionsToStepsWizard), _toConsumableArray(objectsForm));

          var _seen = new Set();

          var _filteredArr = _data.filter(function (el) {
            var duplicate = _seen.has(el.i);

            _seen.add(el.i);

            return !duplicate;
          }).filter(function (r) {
            return r.i !== "step-0";
          });

          setObjectsForm(_filteredArr);
        }
      } else {
        // limpiar de acordiones
        if (!id) setObjectsForm([]);
      }

      localStorage.setItem("formName", formName);
      localStorage.setItem("gridSize", gridSize);
      localStorage.setItem("multiple", multiple);
      localStorage.setItem("isAdvance", isAdvance);
      localStorage.setItem("advanceCount", advanceCount);
      localStorage.setItem("typeForm", typeForm);
      localStorage.setItem("optionsGridLayout", optionsGridLayout);
      setStateLoading(false);
      setOpenModal(false);
    }
  }, [formName, typeForm, gridSize, multiple, isAdvance, optionsGridLayout, advanceCount, itemsMenu, objectsForm, id]);

  var navigate = function navigate(url) {
    return props.history ? props.history.push(url) : props.navigate(url);
  };

  return /*#__PURE__*/React.createElement(_pickers.MuiPickersUtilsProvider, {
    locale: "es",
    utils: _moment.default
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 0
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 2,
    lg: 2,
    xl: 1,
    className: classes.paddingRight10
  }, /*#__PURE__*/React.createElement(_core.Card, {
    className: classes.root,
    variant: "outlined",
    style: {
      position: "sticky",
      top: 0
    }
  }, /*#__PURE__*/React.createElement(_core.CardHeader, {
    title: "Componentes",
    className: classes.cardHeader
  }), /*#__PURE__*/React.createElement(_core.CardContent, null, itemsMenu.map(function (item, i) {
    return /*#__PURE__*/React.createElement(_FormItemsDnd.default, {
      key: i,
      item: item,
      handleDrop: function handleDrop(itemToForm) {
        handleAddItemForm(itemToForm);
      },
      typeForm: typeForm
    });
  })))), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 7,
    lg: 7,
    xl: 8
  }, /*#__PURE__*/React.createElement(_core.Card, {
    className: classes.root,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_core.CardHeader, {
    title: "Formulario ".concat(formName, " ").concat(isAdvance ? "- (Advance grid \"".concat(advanceCount, "\")") : ""),
    className: classes.cardHeader
  }), /*#__PURE__*/React.createElement(_core.CardContent, null, /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, id && !objectsForm.length && stateLoading ? /*#__PURE__*/React.createElement(_Loading.default, null) : /*#__PURE__*/React.createElement(_FormContainersDnd.default, {
    objectsForm: objectsForm,
    handleItemSelected: handleItemSelected,
    handleItemPropertiesChange: handleItemPropertiesChange,
    handleRemoveItem: handleRemoveItem,
    gridSize: gridSize,
    container: containerRef,
    itemProperties: itemProperties,
    optionsGridLayout: optionsGridLayout
  }))))), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 3,
    lg: 3,
    xl: 3,
    className: (0, _clsx.default)(classes.paddingLeft10, classes.marginBottom)
  }, /*#__PURE__*/React.createElement(_core.Card, {
    className: classes.root,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_core.CardHeader, {
    title: "Propiedades del componente",
    className: classes.cardHeader
  }), /*#__PURE__*/React.createElement(_core.CardContent, null, openProperties ? /*#__PURE__*/React.createElement(_FormItemsProperties.default, {
    handlePropertyChange: handleItemPropertyChange,
    handleItemAttribute: handleItemAttribute,
    handleItemValidation: handleItemValidation,
    handleItemSource: handleItemSource,
    handleItemDependencies: handleItemDependencies,
    objectsForm: objectsForm,
    itemProperties: itemProperties,
    handleAddItemForm: handleAddItemForm,
    gridSize: gridSize,
    typeForm: typeForm
  }) : /*#__PURE__*/React.createElement(_core.Box, {
    component: "span"
  }, "Seleccione un item para ver propiedades")))), /*#__PURE__*/React.createElement(_Footer.default, {
    data: objectsForm,
    multiple: multiple,
    gridSize: gridSize,
    typeForm: typeForm,
    isAdvance: isAdvance,
    advanceCount: advanceCount,
    formName: formName,
    onOpenModal: handleOpenModal,
    isUpdate: id,
    token: props.token,
    navigate: navigate
  })), /*#__PURE__*/React.createElement(_Modal.default, {
    open: openModal,
    onOpen: handleModal,
    title: "Definir datos principales del formulario",
    disableBackdropClick: true,
    disableEscapeKeyDown: true
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.Select, {
    value: typeForm,
    onChange: function onChange(e) {
      return setTypeForm(e.target.value);
    },
    displayEmpty: true,
    inputProps: {
      "aria-label": "Without label"
    }
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "simple"
  }, "Simple"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "multiple"
  }, "Multiple"))), typeForm === "multiple" && /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.Select, {
    value: multiple,
    onChange: function onChange(e) {
      return setMultiple(e.target.value);
    },
    displayEmpty: true,
    inputProps: {
      "aria-label": "Without label"
    },
    style: {
      marginTop: 20
    }
  }, Array.from(new Array(30)).map(function (value, i) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: i,
      value: i + 1
    }, i + 1);
  })), /*#__PURE__*/React.createElement(_core.FormHelperText, null, "Formulario multiple")), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Nombre del formulario",
    value: formName,
    onChange: validateFormName,
    style: {
      marginBottom: 20
    },
    helperText: errModal.formName,
    error: errModal.formName !== ""
  }), /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Tama\xF1o de la grilla(m\xE1ximo ".concat(maxColumnsNumber, ")"),
    value: Number(gridSize),
    onChange: validateNumber,
    style: {
      marginBottom: 20
    },
    disabled: typeForm === "multiple" // eslint-disable-next-line no-useless-escape
    ,
    inputProps: {
      pattern: "[1-6]d*"
    }
  }), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "autoSize",
      color: "primary",
      checked: isAutoSize,
      onChange: function onChange(e, checked) {
        setIsAutoSize(checked);
      }
    }),
    label: "Tama\xF1o automatico"
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "allowOverlap",
      color: "primary",
      checked: isAllowOverlap,
      onChange: function onChange(e, checked) {
        setIsAllowOverlap(checked);
      }
    }),
    label: "Permitir superposicion"
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "preventCollision",
      color: "primary",
      checked: isPreventCollision,
      onChange: function onChange(e, checked) {
        setIsPreventCollision(checked);
      }
    }),
    label: "Prevenir colision"
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "showGrids",
      color: "primary",
      checked: isShowGrids,
      onChange: function onChange(e, checked) {
        setIsShowGrids(checked);
      }
    }),
    label: "Mostrar grillas"
  }))), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Remueve todas las limitaciones de alturas de todos los objetos incertados actualmente"
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "isStaticHeigth",
      color: "primary",
      checked: isStaticHeigth,
      onChange: function onChange(e, checked) {
        setIsStaticHeigth(checked);
      }
    }),
    label: "Altura Manual"
  }))), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Altura estatica",
    value: Number(staticHeight),
    disabled: isStaticHeigth,
    onChange: function onChange(e) {
      var val = Number(e.target.value);
      setStaticHeight(val);
    },
    style: {
      marginBottom: 20
    }
  }))), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Margin (X)",
    value: Number(marginSizeX),
    onChange: function onChange(e) {
      var val = Number(e.target.value);
      setMarginSizeX(val);
    },
    style: {
      marginBottom: 20
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Margin (Y)",
    value: Number(marginSizeY),
    onChange: function onChange(e) {
      var val = Number(e.target.value);
      setMarginSizeY(val);
    },
    style: {
      marginBottom: 20
    }
  }))), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Padding (X)",
    value: Number(containerPaddingSizeX),
    onChange: function onChange(e) {
      var val = Number(e.target.value);
      setContainerPaddingSizeX(val);
    },
    style: {
      marginBottom: 20
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    label: "Padding (Y)",
    value: Number(containerPaddingSizeY),
    onChange: function onChange(e) {
      var val = Number(e.target.value);
      setContainerPaddingSizeY(val);
    },
    style: {
      marginBottom: 20
    }
  }))), typeForm === "multiple" && /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "isAdvance",
      color: "primary",
      checked: isAdvance,
      onChange: function onChange(e, checked) {
        setIsAdvance(checked);
      }
    }),
    label: "Es Advance Grid"
  }), isAdvance && /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.Select, {
    value: advanceCount,
    onChange: function onChange(e) {
      return setAdvanceCount(e.target.value);
    },
    displayEmpty: true,
    inputProps: {
      "aria-label": "Without label"
    },
    style: {
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: 1
  }, "1"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: 2
  }, "2"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: 3
  }, "3"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: 4
  }, "4"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: 5
  }, "5")), /*#__PURE__*/React.createElement(_core.FormHelperText, null, "Cantidad de Advance grid")), /*#__PURE__*/React.createElement("div", {
    className: classes.flexEnd
  }, /*#__PURE__*/React.createElement(_core.Button, {
    variant: "text",
    onClick: function onClick() {
      return setOpenModal(false);
    }
  }, "Cancelar"), /*#__PURE__*/React.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: validateModal
  }, "Continuar")))));
}

var _default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend.default)(FormCreate);

exports.default = _default;